import { FirebaseApp, initializeApp } from 'firebase/app';
import { environment } from '../environments/environment';

let app: FirebaseApp | undefined;
let failed = false;

/**
 * Single entry point for the Firebase default app.
 *
 * Everything that needs Firebase must go through here and pass the returned
 * app explicitly, instead of calling initializeApp() in one place and relying
 * on the implicit `[DEFAULT]` registry lookup somewhere else. Returns
 * undefined instead of throwing: Firebase powers presence/analytics only, and
 * a failure there must never take down a caller.
 */
export function getFirebaseApp(): FirebaseApp | undefined {
  if (app || failed) return app;
  try {
    app = initializeApp(environment.firebaseConfig);
  } catch (err) {
    failed = true;
    console.error('Firebase failed to initialize', err);
  }
  return app;
}
